import { render, staticRenderFns } from "./maintenanceForm.vue?vue&type=template&id=2bc34c0a"
import script from "./maintenanceForm.vue?vue&type=script&lang=js"
export * from "./maintenanceForm.vue?vue&type=script&lang=js"
import style0 from "./maintenanceForm.vue?vue&type=style&index=0&id=2bc34c0a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports